export var addDotAtTheEndOfString = function addDotAtTheEndOfString(value) {
  if (!value) return value;
  if (value.charAt(value.length - 1) === '.') return value;
  return "".concat(value, ".");
};